import React, { useEffect, useRef } from 'react';
import { Container, Graphics, Sprite } from '@pixi/react';

import * as PIXI from 'pixi.js';
import WebBottomContainer from '../../containers/web/bottom';
import MenuWrapper from '../../containers/common/menuWrapper';
import Notification from '../../containers/common/notification';
import WinLineWrapper from '../../containers/common/winLineWrapper';
import FreeBetWrapper from '../../containers/common/freeBetWrapper';
import GameLogoWrapper from '../../containers/common/gameLogoWrapper';
import WinPopupWrapper from '../../containers/common/winPopupWrapper';
import InfoSectionContainer from '../../containers/common/infoWrapper';
import GameBoardWrapper from '../../containers/common/gameBoardWrapper';
import LobbyIconWrapper from '../../containers/common/lobbyIconWrapper';
import JackPotInfoWrapper from '../../containers/common/jackPotInfoWrapper';
import GameBackgroundWrapper from '../../containers/common/gameBackgroundWrapper';
import ConnectionPopupWrapper from '../../containers/common/connectionPopupWrapper';

import Gamble from '../../components/common/gamble';
import JackpotScene from '../../components/common/jackpotScene';
import JackPotCongratsPopup from '../../components/common/jackpot/jackPotCongratsPopup';
import BoostedJackpotIcon from '../../components/common/boostedJackpotIcon';
import BoostedJackpot from '../../components/common/boostedJackpot';
import RePlayInfoIconWrapper from '../../containers/common/rePlayInfoIconWrapper';
import TournamentIconWrapper from "../../containers/common/tournamentIconWrapper";

function WebView({
  setMask,
  reelContainerRef,
  winContainerRef,
  touchSpinScreenRef,
  reelContainerConfig,
  touchSpinScreenConfig,
}) {
  const spriteMaskRef = useRef(null);
  useEffect(() => {
    if (spriteMaskRef.current) {
      setMask(spriteMaskRef.current);
    }
  }, [setMask, spriteMaskRef]);

  return (
    <Container>
      <GameBackgroundWrapper />
      <GameLogoWrapper />
      <GameBoardWrapper />
      <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
        <Graphics
          draw={(g) => {
            g.beginFill(0xff700b);
            g.drawRect(-90, -82, 890, 505);
          }}
          ref={(graphicsRef) => setMask(graphicsRef)}
        />
      </Container>
      <Container ref={touchSpinScreenRef} {...touchSpinScreenConfig}>
        <Sprite
          texture={PIXI.Texture.EMPTY}
          width={touchSpinScreenConfig.width}
          height={touchSpinScreenConfig.height}
        />
      </Container>
      <WinLineWrapper />
      <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
      <WinPopupWrapper />
      <WebBottomContainer />
       <TournamentIconWrapper />
      <LobbyIconWrapper />
      <RePlayInfoIconWrapper />
      <BoostedJackpotIcon />
      <JackPotInfoWrapper />
      <Gamble />
      <FreeBetWrapper />
      <BoostedJackpot />
      <InfoSectionContainer />
      <MenuWrapper />
      <JackPotCongratsPopup />
      <JackpotScene />
      <Notification />
      <ConnectionPopupWrapper />
    </Container>
  );
}

export default WebView;
